import { render, staticRenderFns } from "./TheSidebarNav.vue?vue&type=template&id=fed3b684&scoped=true&"
import script from "./TheSidebarNav.vue?vue&type=script&lang=js&"
export * from "./TheSidebarNav.vue?vue&type=script&lang=js&"
import style0 from "./TheSidebarNav.vue?vue&type=style&index=0&id=fed3b684&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed3b684",
  null
  
)

export default component.exports